import React from 'react';
import {useTranslation} from '@wix/yoshi-flow-editor';

export enum TotalAmountDataHook {
  TotalAmountRoot = 'TotalAmount.root',
  TotalAmountValue = 'TotalAmount.subtotalText',
}

export interface TotalAmountProps {
  totalAmount: string;
}

export const TotalAmount = ({totalAmount}: TotalAmountProps) => {
  const {t} = useTranslation();

  return (
    <dl data-hook={TotalAmountDataHook.TotalAmountRoot}>
      <dt>{t('sideCart.subtotal.label')}</dt>
      <dd
        data-hook={TotalAmountDataHook.TotalAmountValue}
        data-wix-sub-totals-value={TotalAmountDataHook.TotalAmountValue}>
        {totalAmount}
      </dd>
    </dl>
  );
};
